module.exports = __webpack_public_path__ + "img/L_QC.cd5a9f6c.png";